module.exports = __webpack_public_path__ + "img/3fc01cc6c6fcfe97701bdcfe99cf6169.png";